import * as React from 'react';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import { Mention, MentionsInput } from 'react-mentions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getBidTotal } from '../pages/Enquiry/InquiryUtils';

const styles = (theme: any) => ({
  suggestionNav: {
    display: 'block',
    padding: '3px 20px',
    clear: 'both',
    fontWeight: 400,
    lineHeight: 1.428571429,
    color: theme.colors.textSecondary,
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'none',
      color: theme.colors.text,
      backgroundColor: theme.colors.bgSubtle,
    },
  },
});

const mentionInputStyle = {
  width: '85%',
  height: '45px',
  lineHeight: '30px',
  control: {
  },

  highlighter: {
  },

  input: {
    paddingLeft: 10,
    paddingRight: 30,
    textOverflow: 'ellipsis',
    margin: 0,
    height: 40,
    paddingTop: 6,
    fontSize: 16,
    lineHeight: 1.5,
    border: 'px solid #d9d9d9',
    borderRadius: 4,
    transition: 'all 0.3s',
  },

  '&singleLine': {
    control: {
    },

    highlighter: {
    },

    input: {
    },
  },

  '&multiLine': {
    control: {
    },

    highlighter: {
    },

    input: {
    },
  },

  suggestions: {
    list: {
      overflow: 'scroll',
      height: 100,
      width: 200,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    },

    item: {
      '&focused': {
      },
    },
  },
};

class InputWithMentions extends React.PureComponent<any, any> {
  state = {
    value: '',
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    this.setState({ value: e.target.value });
    onChange(e.target.value);
  }

  render() {
    const { suggestions, classes } = this.props;
    const { value } = this.state;
    return (
      <MentionsInput
        placeholder="Type here to add a comment!"
        value={value}
        onChange={this.handleChange}
        style={mentionInputStyle}
        >
          {suggestions.map(({ trigger, type, list }) =>
            <Mention
            trigger={trigger}
            markup={`<span style="color: rgb(24, 144, 255);" data-id="comments-${type}-__id__">__display__</span> `}
            displayTransform={(id, display) => {
              const suggestion = list.find(item => item.id === id);
              return `${trigger}${suggestion.display} `;
            }}
            data={list && list.map((suggestion) => {
              return {
                id: suggestion.id,
                display: `${suggestion.display}`,
              };
            })}
            renderSuggestion={(
              suggestion,
              search,
              highlightedDisplay,
              index,
              focused,
            ) => {
              return <div className={classes.suggestionNav}>
                {highlightedDisplay}
                </div>;
            }}
          />,
          )}
      </MentionsInput>
    );
  }
}

const mapStateToProps = ({ masterData, staticData }) => ({
  currencySymbols: masterData.currencySymbols,
  containerTypesKeyVal: staticData.containerTypesKeyVal,
});

const InputWithMentionsStyled = injectSheet(styles)(InputWithMentions);
export default withRouter(connect(mapStateToProps, null)(InputWithMentionsStyled));
